import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL || ''}/api`;

const api = axios.create({
  baseURL: API_BASE,
  timeout: 30000,
});

api.interceptors.request.use((config) => {
  // Pick the right token based on the API path
  const url = config.url || '';
  let authToken = null;
  if (url.includes('customer-portal')) {
    authToken = localStorage.getItem('customer_token');
  } else if (url.includes('agent-portal')) {
    authToken = localStorage.getItem('agent_token');
  }
  // Fallback to admin token
  if (!authToken) {
    authToken = localStorage.getItem('token');
  }
  if (authToken) {
    config.headers.Authorization = `Bearer ${authToken}`;
  }
  // Prevent caching of API responses
  config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
  config.headers['Pragma'] = 'no-cache';
  return config;
});

// Retry logic for network errors
const MAX_RETRIES = 2;
const RETRY_DELAY = 1000;

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    // Retry on network errors or 5xx (not on 4xx like 401/403)
    const isNetworkError = !error.response && error.code !== 'ECONNABORTED';
    const isServerError = error.response && error.response.status >= 500;
    const isTimeout = error.code === 'ECONNABORTED';

    if ((isNetworkError || isServerError || isTimeout) && (!config._retryCount || config._retryCount < MAX_RETRIES)) {
      config._retryCount = (config._retryCount || 0) + 1;
      await new Promise(r => setTimeout(r, RETRY_DELAY * config._retryCount));
      return api(config);
    }

    // Auto-logout only on 401 (expired/invalid token)
    if (error.response && error.response.status === 401) {
      const isLoginPage = window.location.pathname === '/login' || window.location.pathname === '/customer-login';
      if (!isLoginPage) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        window.location.href = '/login';
      }
    }

    return Promise.reject(error);
  }
);

export default api;
